import { useEffect, useState } from "react";
import { db } from "firebaseConfig";
import { GenericConverter } from "utils/firestoreConverters";
import { LISTING_PAGE_VIEWS_COLLECTION_NAME } from "../@types/sharedSchema";
import type { ListingPageViewsDocument } from "../@types/sharedSchema";

type UseListingPageViewsResult = {
  viewData: ListingPageViewsDocument | null;
  loading: boolean;
};

export function useListingPageViews(
  favoriteListingsId: string | undefined
): UseListingPageViewsResult {
  const [viewData, setViewData] = useState<ListingPageViewsDocument | null>(null);
  const [loading, setLoading] = useState(!!favoriteListingsId);

  useEffect(() => {
    if (!favoriteListingsId) {
      setViewData(null);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = db
      .collection(LISTING_PAGE_VIEWS_COLLECTION_NAME)
      .doc(favoriteListingsId)
      .withConverter(GenericConverter<ListingPageViewsDocument>())
      .onSnapshot(
        (snapshot) => {
          setViewData(snapshot.data() ?? null);
          setLoading(false);
        },
        (error) => {
          console.error("useListingPageViews error", error);
          setLoading(false);
        }
      );

    return unsubscribe;
  }, [favoriteListingsId]);

  return { viewData, loading };
}
